// import { uniqBy } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

function SummaryList({ cmpVariables, ipVariables, steps }) {
  const isRequired = (type) => {
    if (type === 0) return '必填';
    if (type === 1) return '选填';
  };

  return (
    <Root>
      <Title>变量汇总</Title>
      {steps.map((step, index) => (
        <Container key={index}>
          <Bolder>{step.prettyText}</Bolder>
          {cmpVariables
            .filter((item) => item.stepId === step.stepId)
            .map((varItem) => (
              <div key={varItem.id}>
                [集群变量][{isRequired(varItem.variableType)}] {varItem.key}={varItem.defaultValue}
              </div>
            ))}
          {ipVariables
            .filter((item) => item.stepId === step.stepId)
            .map((varItem) => (
              <div key={varItem.id}>
                [{varItem.host.serviceIp || varItem.host.hostIp}][
                {isRequired(varItem.variableType)}] {varItem.key}={varItem.defaultValue}
              </div>
            ))}
        </Container>
      ))}
    </Root>
  );
}

export default connect((state) => ({
  cmpVariables: state.execFlow.cmpVariables,
  ipVariables: state.execFlow.ipVariables,
  steps: state.execFlow.steps,
}))(SummaryList);

const Root = styled.div`
  width: 250px;
  padding: 16px 20px;
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const Bolder = styled.div`
  font-weight: bold;
`;

const Container = styled.div`
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.3;
  color: #202b40;
  padding-left: 2px;
`;
